import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "../../axios";
import { colors, radius } from "../../styles/theme/tokens";

// Фінанси періоду: оборот і чистий дохід вносить власник, ЗП вчителів рахується з відмічених уроків (можна виправити).
// Дані: GET/PUT /admin/finance. Порожнє поле при збереженні = повернути авто.
const fmt = (n) => Math.round(n).toLocaleString("uk-UA");

const FIELDS = [
  { key: "revenue", label: "Оборот", auto: (a) => `з «Пакет» в LMS: ${fmt(a.revenue)} грн` },
  { key: "salaries", label: "ЗП вчителів", auto: (a) => `з відмічених уроків (${a.lessons})${a.renewalBonuses ? ` + бонуси за продовження ${a.renewalBonuses} грн` : ""}` },
  { key: "net", label: "Чистий дохід", auto: () => "оборот − ЗП" },
];

export default function PeriodFinance({ from }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setError(false);
    setEditing(null);
    axios
      .get(`admin/finance?from=${from}`)
      .then((res) => setData(res.data))
      .catch(() => setError(true));
  }, [from]);

  const save = (key, value) => {
    setSaving(true);
    axios
      .put("admin/finance", { from, [key]: value })
      .then((res) => { setData(res.data); setEditing(null); })
      .catch(() => alert("Не вдалося зберегти"))
      .finally(() => setSaving(false));
  };

  if (error) return <Muted>Не вдалося завантажити фінанси періоду</Muted>;
  if (!data) return null;

  return (
    <Grid>
      {FIELDS.map(({ key, label, auto }) => {
        const manual = data.manual[key] !== null;
        return (
          <Tile key={key} $main={key === "net"}>
            <Label>{label}</Label>
            {editing === key ? (
              <Edit onSubmit={(e) => { e.preventDefault(); save(key, draft.trim()); }}>
                <Input
                  autoFocus
                  inputMode="numeric"
                  value={draft}
                  placeholder={String(data[key])}
                  onChange={(e) => setDraft(e.target.value.replace(/[^\d-]/g, ""))}
                />
                <Btn type="submit" disabled={saving}>Зберегти</Btn>
                <Link type="button" onClick={() => setEditing(null)}>скасувати</Link>
              </Edit>
            ) : (
              <Value onClick={() => { setEditing(key); setDraft(manual ? String(data.manual[key]) : ""); }} title="Натисніть, щоб змінити">
                {fmt(data[key])} грн <Pen>✎</Pen>
              </Value>
            )}
            <Hint>
              {manual ? (
                <>
                  вручну · <Link type="button" onClick={() => save(key, null)} disabled={saving}>повернути авто</Link>
                </>
              ) : (
                `авто: ${auto(data.auto)}`
              )}
            </Hint>
          </Tile>
        );
      })}
    </Grid>
  );
}

const Grid = styled.div`display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: 10px; margin-bottom: 14px;`;
const Tile = styled.div`
  border-radius: ${radius.md}; padding: 12px;
  background: ${(p) => (p.$main ? colors.successSoft : colors.surface)};
  border: 1px solid ${(p) => (p.$main ? colors.success : colors.line)};
`;
const Label = styled.div`font-size: .8rem; font-weight: 700; color: ${colors.muted}; text-transform: uppercase; letter-spacing: .03em;`;
const Value = styled.div`font-size: 1.45rem; font-weight: 800; color: ${colors.ink}; cursor: pointer; margin: 4px 0;`;
const Pen = styled.span`font-size: .85rem; color: ${colors.muted};`;
const Hint = styled.div`font-size: .78rem; color: ${colors.muted};`;
const Edit = styled.form`display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin: 4px 0;`;
const Input = styled.input`
  width: 110px; padding: 6px 8px; font-size: 1rem; border: 1px solid ${colors.line};
  border-radius: ${radius.md}; color: ${colors.ink}; background: ${colors.surface};
`;
const Btn = styled.button`
  border: 0; border-radius: ${radius.pill}; padding: 6px 12px; font-weight: 700; cursor: pointer;
  background: ${colors.brandDark}; color: #fff;
  &:disabled { opacity: .5; }
`;
const Link = styled.button`border: 0; background: none; padding: 0; color: ${colors.brandDark}; cursor: pointer; font-size: inherit; text-decoration: underline;`;
const Muted = styled.p`color: ${colors.muted}; font-size: .9rem; margin: 0 0 14px;`;
